<template>
  <div class="editable-cell">
    <div v-if="editable" class="editable-cell-input-wrapper">
       <a-input v-model="wideObj.minAmount" class="inputW_">
        <a-select v-model="wideObj.minIsContain" slot="addonAfter" style="width: 70px">
          <a-select-option value="1">
            含
          </a-select-option>
          <a-select-option value="0">
            不含
          </a-select-option>
        </a-select>
      </a-input>
      —
      <a-input v-model="wideObj.maxAmount" class="inputW_">
        <a-select v-model="wideObj.maxIsContain" slot="addonAfter" style="width: 70px">
          <a-select-option value="1">
            含
          </a-select-option>
          <a-select-option value="0">
            不含
          </a-select-option>
        </a-select>
      </a-input>

      <a-icon type="check" class="editable-cell-icon-check" @click="check" />
    </div>
    <div v-else class="editable-cell-text-wrapper">
      {{ formatWideObj(wideObj) || " " }}
      <a-icon type="edit" class="editable-cell-icon" @click="edit" />
    </div>
  </div>
</template>

<script>
import common from './common'
export default {
  props: {
    wideObj: {
        type: Object,
        default: () => {
            return {
                minAmount: 100,
                minIsContain: "0",
                maxAmount: 1000,
                maxIsContain: "1"
            }
        }
    },
  },
  monted() {
      console.log(this.wideObj,"=====")
  },
  data() {
    return {
      editable: false,
    };
  },
  methods: {
      ...common,
    check() {
      this.editable = false;
      this.$emit("change", this.wideObj);
    },
    edit() {
      this.editable = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.editable-cell {
  position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
  padding-right: 24px;
}

.editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
  position: absolute;
  right: 0;
  width: 20px;
  cursor: pointer;
}

.editable-cell-icon {
  line-height: 18px;
  display: none;
}

.editable-cell-icon-check {
  line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: #108ee9;
}

.editable-add-btn {
  margin-bottom: 8px;
}

.inputW_{
 width: 170px;
}
</style>